export default {
    // common
    yes: 'Yes',
    no: 'No',
    cancel: 'Cancel',
    all: 'All',
    athlete: 'Athlete | Athletes',
    coach: 'Coach | Coaches',
    filter: 'Filter',
    closeFilter: 'Close filter',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'E-mail',
    save: 'Save',
    clear: 'Clear',
    submit: 'Submit',
    loadMore: 'Load more',
    more: 'More',
    everybody: 'Everybody',
    close: 'Close',
    next: 'Next',
    or: 'OR',
    help: 'Help',
    add: 'Add',
    create: 'Create',
    createAndContinue: 'Save and create next crew',
    finish: 'Finish',
    update: 'Update',
    any: 'Any',
    areYouSureToDeleteThisFile: 'Are you sure you want to delete this file?',
    browse: 'Browse',

    // login and sign up
    login: 'Login',
    google: 'Google',
    invalidEmailAddress: 'Invalid email address',
    emptyPassword: 'Password cannot be empty',
    signUp: 'Sign Up',
    forgotPassword: 'Forgot password',
    signUpForNewAccount: 'Or <span class="text-danger">sign up</span> for a new account',
    resetPassword: 'Reset Password',
    repeatPassword: 'Repeat Password',
    backToLogin: 'Back to login',
    yourFirstName: 'Your First Name',
    yourLastName: 'Your Last Name',
    yourPassword: 'Your Password',
    youEmailAddress: 'Your Email Address',
    success: 'Success',
    iAccept: 'I accept',
    termsAndConditions: 'Terms and Conditions',
    privacyPolicy: 'Privacy Policy',
    receiveProductUpdates: 'Receive Product Updates',
    receiveMarketingUpdates: 'Receive Marketing Updates',
    firstNameIsRequired: 'First name is required',
    lastNameIsRequired: 'Last name is required',
    passwordIsRequired: 'Password is required',
    passwordConfirmationIsRequired: 'Password confirmation is required',
    needToAcceptTermsAndConditions: 'You need to accept Terms and Conditions to register',
    needToAcceptPrivacyPolicy: 'You need to accept our Privacy Policy to register',
    successfulSignUp: 'Successful sign up',
    successfulSignUpMessage:
        'You have successfully created an Account in Ludum. Please check your email in order to validate your ' +
        'account and login.',

    // header dropdown
    addMorningMonitoring: 'Add Morning Monitoring',
    addDiaryEntry: 'Add Diary Entry',
    newSession: 'New Session',
    newEvent: 'New Event',
    myProfile: 'My Profile',
    manageSettings: 'Manage Settings',
    logout: 'Logout',
    edit: 'Edit',
    remove: 'Remove',
    favourite: 'Favourite',
    joinAClub: 'Join a Club',
    createClub: 'Create Club',
    toggleMenu: 'Toggle menu',
    schedule: 'Schedule',
    hours: 'Hours',
    minutes: 'Minutes',

    // side navigation
    home: 'Home',
    dashboard: 'Dashboard',
    sessions: 'Sessions',
    mySquads: 'My {label}',
    reports: 'Reports',
    clubMembers: 'Club members',
    facebook: 'Facebook',
    twitter: 'Twitter',
    instagram: 'Instagram',
    allRightsReserved: 'All rights reserved',
    tcs: 'T&Cs',
    english: 'English',
    german: 'German',
    chinese: 'Chinese',
    switchToAdmin: 'Switch to Admin',

    // settings
    accountDetails: 'Account Details',
    integrations: 'Integrations',
    myClubs: 'My Clubs',
    billing: 'Billing',
    requestToJoinClub: 'Request to Join a Club',

    // settings - account details
    details: 'Details',
    contactNumber: 'Contact Number',
    secondaryEmail: 'Secondary E-mail',
    locationAndTimezone: 'LOCATION / TIMEZONE',
    gender: 'Gender',
    height: 'Height',
    cm: 'cm',
    male: 'Male',
    female: 'Female',
    weight: 'Weight',
    kg: 'kg',
    maxHeartRate: 'Max Heart Rate',
    selectedClub: 'Selected Club',
    scull: 'Scull',
    sweep: 'Sweep',
    cox: 'Cox',
    bowStarboard: 'Bow/Starboard',
    strokesidePort: 'Strokeside/Port',
    both: 'Both',
    username: 'Username',
    password: 'Password',
    oldPassword: 'Old Password',
    newPassword: 'New Password',
    reenterPassword: 'Re-enter Password',
    changeImage: 'Change Image',
    chooseSide: 'Choose Side',
    dataSuccessfullySaved: 'Data successfully saved',

    // settings - integrations
    thirdParty: 'Third Party',
    status: 'Status',
    account: 'Account',
    action: 'Action',
    connected: 'Connected',
    notConnected: 'Not Connected',
    connect: 'Connect',
    disconnect: 'Disconnect',
    floatIntegration: 'Float Integration',
    garminIntegration: 'Garmin Integration',
    redirectingToIntegrationsPage: 'Redirecting to the Integrations page...',

    // settings - my clubs
    selectImage: 'Select Image',
    club: 'Club',
    position: 'Position',
    areYouSureToLeaveClub: 'Are you sure you want to leave the club?',
    areYouSureToJoinClub: 'Are you sure you want to join the club?',
    successfullyLeftClub: 'You successfully left the club',
    leave: 'Leave',
    rejoin: 'Rejoin',
    name: 'Name',
    description: 'Description',
    country: 'Country',
    searchForClub: 'Search for club',
    noResultsForSearchedTerm: 'No results for searched term',
    sendRequest: 'Send request',
    gmt: 'GMT',
    gmts: 'GMTs',
    clubDetails: 'Club details',
    wb: 'WB',
    gmtDistribution: 'GMT Distribution',

    // settings - club list
    areYouSureToAcceptInvitation: 'Are you sure you want to accept invitation from the club?',
    areYouSureToRejectInvitation: 'Are you sure you want to reject invitation from the club?',

    // settings - edit club - defaults
    defaults: 'Defaults',
    allYourSessionsAreSetTo: 'All your session are set to',
    competitive: 'Competitive',
    nonCompetitive: 'Non Competitive',

    // settings-dashboard-add crew auto import
    autoImportValueAutomatic: 'Import Automatically',
    assignManually: 'Assign Manually',
    autoImportValueOff: 'Do not import',
    ignore: 'Ignore',
    viewAllThirdPartyIntegrations: 'View all third-party integrations',
    connectThirdParties: 'Connect third parties',
    connectThirdPartiesMessage:
        'Connecting third parties allows you to easily import sessions, heart rate and other ' +
        'data. We’ll integrate them with your Ludum account, helping you to make the most of the platform',
    previous: 'Previous',
    actionRequired: 'Action required',
    completedOn: 'Completed on',
    assignDataToSessionOrCreateNewSession: 'Assign this data to an existing session, or create a new one',
    assignToExistingSession: 'Assign to existing session',
    createNewSession: 'Create new session',
    howDidYouFindSession: 'How did you find the session?',
    createSessionAs: 'Create session as',
    autoImportEmptyAgendaMessage: "You have no session's in your calendar to assign this session to.",
    assignToSession: 'Assign to session',
    importAsA: 'Import as a',
    selectClub: 'Select club',
    assignToClub: 'Assign to Club',
    doYouWantToCreateCrew: 'Do you want to create crew for this auto import?',
    waterSessionAutoImportInitialMessage: 'To finish Auto Import please create a new crew and assign yourself to it.',
    waterSessionAutoImportOnSuccessMessage: 'Auto import completed successfully. Choose action:',
    goToDashboard: 'Go to Dashboard',
    stayOnPage: 'Stay on the page',
    noCrew: 'No crew',

    // squads
    squad: 'Squad | Squads',
    addSquad: 'Add {label}',
    editSquad: 'Edit {label}',
    deleteSquad: 'Delete {label}',
    saveSquad: 'Save {label}',
    areYouSureToDeleteSquad: 'Are you sure you want to delete {label}?',
    squadsCount: 'No {label} | {label} | {label}',
    allSquads: 'All {label}',
    squadName: '{label} name',
    selectBySquad: 'SELECT BY {label}',
    selectByAthletes: 'SELECT BY ATHLETES',
    selectByIndividuals: 'SELECT BY INDIVIDUALS',
    healthy: 'Healthy',
    ill: 'Ill',
    injured: 'Injured',
    assigned: 'Assigned',
    illBadge: 'Ill',
    injuredBadge: 'Injured',

    // club members
    sortBy: 'Sort By',
    invite: 'Invite',
    multiInvite: 'Multi Invite',
    number: 'Number',
    dateOfBirth: 'Date of Birth',
    accept: 'Accept',
    reject: 'Reject',
    bulkAction: 'Bulk action',
    areYouSureToRemoveMember: 'Are you sure you want to remove the member?',
    invitee: 'Invitee',
    clubManager: 'Club manager',
    acceptAndAssign: 'Accept & Assign',
    editMember: 'Edit member',
    roleInClub: 'Role in Club',
    permissionsInClub: 'Permissions in club',
    inviteMember: 'Invite Member',
    sendInvitation: 'Send Invitation',
    selectRole: 'Select role',
    multiImport: 'Multi Import',
    uploadFile: 'Upload file',
    downloadSample: 'Download sample',
    manager: 'Manager | Managers',
    invited: 'Invited',
    pending: 'Pending',
    left: 'Left',
    removeMember: 'Remove member',
    acceptMember: 'Accept member',
    rejectMember: 'Reject member',
    resendInvitation: 'Resend Invitation',
    role: 'Role | Roles',

    // wall posts
    wallPost: 'Wall Post | Wall Posts',
    writeSomething: 'Write something...',
    attachImageOrFile: 'Attach Image or File',
    post: 'Post',
    wrote: 'wrote',
    comment: 'Comment | Comments',
    like: 'Like',
    uploadingFile: 'Uploading file...',
    areYouSureToDeleteWallPost: 'Are you sure you want to delete this wall post?',
    file: 'File | Files',
    photo: 'Photo | Photos',
    video: 'Video | Videos',
    document: 'Document | Documents',

    // add morning monitoring
    selectDate: 'Select Date',
    wakingHr: 'Waking HR',
    standingHr: 'Standing HR',
    bpm: 'bpm',
    bodyMass: 'Body Mass',
    hydration: 'Hydration',
    hydrated: 'Hydrated',
    yesterdayTraining: "Yesterday's Training",
    sleepQuality: 'Sleep Quality',
    lowScoreEffectedBy: 'My low score is effected by',
    perceivedShape: 'Perceived Shape',
    other: 'Other',

    // session
    overview: 'Overview',
    results: 'Results',
    crew: 'Crew | Crews',
    attendance: 'Attendance',
    addScores: 'Add Scores',
    attending: 'Attending',
    notAttending: 'Not Attending',
    alternative: 'Alternative',
    createdBy: 'Created by',
    lastEditedBy: 'Last edited by',
    emptyCrewCreateCrew: 'Create crews for this session',
    crewNoResults: 'No results',
    on: 'on',
    areYouSureToDeleteSession: 'Are you sure you want to delete this session?',
    youHaveChangedYourClub: 'You have changed your club',
    alreadyInCrewOnThisSession: 'Athletes from other crews in this session',

    // session - attendance
    athletesName: 'Athletes Name',
    allAttending: 'All attending',
    allNotAttending: 'All not attending',
    coachesName: 'Coaches Name',

    // session - overview
    plannedDistance: 'Planned Distance',
    plannedTime: 'Planned Time',
    noOfPieces: 'No. of Pieces',
    noOfExercises: 'No. of Exercises',
    noOfCrews: 'No. of Crews',
    rpe: 'RPE',
    avgRpe: 'Avg. RPE',
    notSet: 'Not set',
    workStructure: 'Work Structure',
    noWorkStructure: 'No Work Structure',
    createWorkStructure: 'Create Work Structure',
    exercise: 'Exercise | Exercises',
    group: 'Group | Groups',
    total: 'Total',
    participants: 'Participants',
    addParticipants: 'Add participants',
    noParticipantsInThisSession: 'No Participants in this session',
    addAthletes: 'Add Athletes',

    // session - crew
    filterBoats: 'Filter Boats',
    notifyCrew: 'Notify Crew',
    newCrew: 'New Crew',
    crewName: 'Crew Name',
    addFavourite: 'Add Favourite',
    unassigned: 'Unassigned',
    recent: 'Recent',
    favouriteCrewsListEmpty: 'Favourite crews list is empty',
    selectABoatFromAbove: 'Select a boat from above',
    copyToAllPieces: 'Copy to all pieces',
    updateFavouriteCrew: 'Update favourite crew',
    bow: 'Bow',
    stroke: 'Stroke',
    sculler: 'Sculler',
    undefined: 'Undefined',
    box: 'Box',
    searchForAthletes: 'Add Athlete',
    emptyAthleteSlot: 'Empty seat',
    addCrew: 'Add Crew | Add Crews',
    createCrew: 'Create Crew | Create Crews',
    updateCrew: 'Update Crew | Update Crews',
    swapAthletes: 'Add/Swap Athletes',
    noAthletes: 'No athletes in this group',
    seat: 'SEAT',
    filterAthletes: 'Filter Athletes',
    boatType: 'Boat Type',
    allPieces: 'All pieces',
    selectPieces: 'Select pieces',
    noCrews: 'No crews for this session',
    unassignedCrews: 'Unassigned',
    favouriteCrews: 'Favourite',
    recentCrews: 'Recent',
    assignCrew: 'Assign Crew',
    assignCrews: 'Assign Crews',
    selectCrew: 'Select Crew',
    selectedCrews: 'Selected Crews',
    addMissingAthletes: 'Add missing athletes',
    availableSessions: 'Available sessions',
    crewsNoSessions: 'No sessions available',
    generalNoCrews: 'No crews',

    // session - results
    avePower: 'Ave. Power',
    noFloatResults: 'No Float data have been added, please add data to view results',
    session: 'Session | Sessions',
    alternativeOverallSummary: 'Alternative Overall Summary',
    alternativeType: 'Alternative Type',
    split: 'Split | Splits',
    aveSplit: 'Ave. Split',
    min: 'min',
    heartRate: 'Heart Rate',
    gps: 'GPS',
    overall: 'Overall',
    barGraph: 'Bar Graph',
    lineGraph: 'Line Graph',
    time: 'Time',
    gpsTime: 'GPS Time',
    bike: 'Bike',
    ergo: 'Ergo',
    sc: 'S&C',
    swim: 'Swim',
    water: 'Water',
    run: 'Run',
    length: 'Length',
    score: 'Score',
    aveScore: 'Ave. Score',
    rank: 'Rank',
    aveHr: 'Ave. HR',
    hr: 'HR',
    aveWatts: 'Ave. Watts',
    watts: 'Watts',
    aveCadence: 'Ave. Cadence',
    cadence: 'Cadence',
    aveLactates: 'Ave. Lactates',
    lactates: 'Lactates',
    lactate: 'Lactate',
    totalTime: 'Total Time',
    totalDistance: 'Total Distance',
    pace: 'Pace',
    avePace: 'Ave. Pace',
    avePacePiece: 'Ave. Pace Piece',
    peakPower: 'Peak power',
    rate: 'Rate',
    aveRate: 'Ave. Rate',
    aveRpe: 'Ave. RPE',
    power: 'Power',
    strokeLength: 'Stroke length',
    energy: 'Energy',
    avePeakForce: 'Ave. Peak Force',
    realPeakForcePosition: 'Real Peak Force Position',
    dateDone: 'Date Done',
    segments: 'Segments',
    resultsSummary: 'Results summary',
    sessionComparisons: 'Session comparisons',
    scoreComparisons: 'Score comparisons',
    values: 'Values',
    individuals: 'Individuals',
    type: 'Type',
    wKg: 'W/Kg',
    aveWKg: 'Ave. W/Kg',
    ergoType: 'Ergo Type',
    overallSummary: 'Overall Summary',
    liftsByAthlete: 'Lifts by Athlete',
    liftByExercise: 'Lift by exercise',
    set: 'Set | Sets',
    rep: 'Rep | Reps',
    chooseAthlete: 'Choose Athlete',
    totalTonnage: 'Total tonnage',
    totalWeight: 'Total Weight',
    speed: 'Speed',
    speedMs: 'Speed (m/s)',
    aveSpeed: 'Ave. Speed',
    maxSpeed: 'Max Speed',
    maxPace: 'Max Pace',
    maxHr: 'Max HR',
    timeLessThenHalfSecond: 'Time < 0.5 m/s',
    crewGmtLevels: 'Crew GMT levels',
    percentageInEachGmtLevel: '% in each GMT level',
    percentageGmt: 'Percentage (% gmt)',
    aveTime: 'Ave. Time',
    aveDistance: 'Ave. Distance',
    crewsMap: 'Crews Map',
    athletesMap: 'Athletes Map',
    speedGraph: 'Speed Graph',
    sessionHrByLevels: 'Session HR by Levels',
    percentageInEachHrLevel: '% in each HR level',
    level: 'Level',
    showAllAthletes: 'Show all athletes',
    hideAllAthletes: 'Hide all athletes',
    showAllCrews: 'Show all crews',
    hideAllCrews: 'Hide all crews',
    hideAll: 'Hide all',
    noResults: 'No scores have been added, please add scores to view results',
    noHeartRateResults: 'No Heart Rate data have been added, please add data to view results',
    noGpsResults: 'No GPS data have been added, please add data to view results',

    // session - import data
    importData: 'Import Data',
    addIntegration: 'Add Integration',
    importText: 'IMPORT',
    piece: 'Piece | Pieces',

    // add score
    addResults: 'Add Results',
    saveAndView: 'Save and View',
    saveScores: 'Save Scores',
    updateScores: 'Update Scores',
    result: 'Result | Results',
    byAthlete: 'By athlete',
    byCrew: 'By crew',
    didNotAttend: 'Didn’t Attend',
    flag: 'Flag',
    distance: 'Distance',
    noOfAthletes: 'No. of Athletes',
    noOfCoaches: 'No. of Coaches',
    data: 'Data',
    peakForcePosition: 'Peak Force Position',
    toAddScoresAddCrewsRowing: 'To add scores to the rowing session you need to make crews and structure',
    toAddScoresAddCrewsKayakCanoe: 'To add scores to the kayak/canoe session you need to make crews and structure',
    startTime: 'Start Time',
    startDistance: 'Start Distance',
    finishTime: 'Finish Time',
    finishDistance: 'Finish Distance',
    finalTime: 'Final Time',
    finalDistance: 'Final Distance',
    multiSport: 'Multi Sport',
    backToSessionType: 'Back to Session Type',
    sessionListIsEmpty: 'Session list is empty.',
    noAddScoresStructure: 'To add scores, please add session structure and participants',
    noAddScoresStructureSc: 'To add scores, please add session structure and participants to exercises',

    // create session and event
    createSession: 'Create Session',
    editSession: 'Edit Session',
    updateSession: 'Update Session',
    sessionName: 'Session Name',
    work: 'Work',
    permission: 'Permission | Permissions',
    yourSessionWasCreated: 'Your session was created',
    viewSession: 'View Session',
    addMoreDetails: 'Add More Details',
    addLessDetails: 'Add Less Details',
    location: 'Location',
    intensity: 'Intensity | Intensities',
    focus: 'Focus | Focuses',
    addTags: 'Add Tags',
    selectExercise: 'Select Exercise',
    custom: 'Custom',
    exerciseName: 'Exercise Name',
    lactateTolerance: 'Lactate Tolerance',
    addAllScores: 'Add all scores',
    repeat: 'Repeat',
    frequency: 'Frequency',
    daily: 'Daily',
    weekly: 'Weekly',
    monthly: 'Monthly',
    yearly: 'Yearly',
    every: 'Every',
    onThe: 'On the',
    each: 'Each',
    setBySelectingDays: 'Set by selecting days',
    setByChoosingFrequency: 'Set by choosing frequency',
    day: 'Day | Days',
    week: 'Week',
    month: 'Month',
    year: 'Year',
    first: 'First',
    second: 'Second',
    third: 'Third',
    fourth: 'Fourth',
    until: 'Until',
    setEndDate: 'Set end date',
    removeEndDate: 'Remove end date',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    jan: 'Jan',
    feb: 'Feb',
    mar: 'Mar',
    apr: 'Apr',
    may: 'May',
    jun: 'Jun',
    jul: 'Jul',
    aug: 'Aug',
    sep: 'Sep',
    oct: 'Oct',
    nov: 'Nov',
    dec: 'Dec',
    single: 'Single',
    multiple: 'Multiple',
    variable: 'Variable',
    byDistance: 'By Distance',
    byTime: 'By Time',
    repetition: 'Repetition | Repetitions',
    rest: 'Rest',
    addGroup: 'Add Group',
    workHeaderMessage:
        'Create a structure for collecting the work done on the ergo. You can always add this later or athletes can ' +
        'add their own.',
    createEvent: 'Create Event',
    editEvent: 'Edit Event',
    updateEvent: 'Update Event',
    eventName: 'Event Name',
    yourEventWasCreated: 'Your event was created',
    viewEvent: 'View event',
    cannotRemove: 'Cannot remove creator.',
    nameGoesHere: 'Name goes here',
    infoTooltipEditSessionText: 'This permission will allow the user to edit the session.',
    infoTooltipAddAllScoresSessionText: 'This permission will allow the user to add scores for every athlete.',
    infoTooltipEditEventText: 'This permission will allow the user to edit the event.',

    // repeat session
    allFutureEvents: 'All future events',
    onlyThisEvent: 'Only this event',

    // dashboard
    yourAgenda: 'Your agenda',
    view: 'View',
    noSessionsComing: 'No sessions coming up, plan your next session',
    mostRecentSession: 'Most Recent Session',
    yourRecentSessionWillAppearHere: 'Your most recent session will appear here.',
    activity: 'Activity',
    today: 'Today',
    notification: 'Notification | Notifications',
    nextSession: 'Next Session',
    createNextSession: 'Create your next session.',

    // Dashboard - Training Load Scores
    informationAboutScores: 'Information about scores',
    informationAboutScoresTabText:
        'Using relationships between your heart rate, morning monitoring and session feedback it’s possible to ' +
        'calculate a Cardiac Training Load Score. Over time this score can help you measure and understand when to ' +
        'train more or less, as well as prevent injury.',
    informationAboutScoresTabButton: 'Connect Integrations to activate Cardiac Training Load Scores',
    informationAboutScoresT2Title: 'ETS Score',
    informationAboutScoresT2Text:
        'In 2014 Rice et al. proposed a more sophisticated method of calculating a training score for each session. ' +
        'It more precisely takes into account the effect of high intensity work, as well as taking into account the ' +
        'type of exercise you are doing.',
    informationAboutScoresTrimpTitle: 'TRIMP Score',
    informationAboutScoresTrimpText:
        'Developed by Banister in 1990, TRIMP (Training Impulse) is a measure of training load. It refers to the ' +
        'amount of time spent in each training zone to give a number to reflect the intensity of the exercise.',
    informationAboutScoresFosterTitle: 'Foster Score',
    informationAboutScoresFosterText:
        'Published in 2001, Foster et al. proposed a method of calculating training load that did not require a ' +
        'Heart rate monitor. It simply multiplies Rating of Perceived Exertion (RPE) by the duration of the session. ' +
        'The duration can be entered via importing wearable data or by filling in the time field in the session.',
    readMore: 'Read More',
    compareTo: 'Compare to',

    // new dashboard
    clubTraining: 'Club Training',
    cardiacTrainingLoad: 'Training Scores',
    ct: 'CT',
    ctl: 'TS',
    mm: 'MM',
    lastWeek: 'last week',
    lastMonth: 'last month',
    lastYear: 'last year',
    vs: 'vs',
    thisWeek: 'This week',
    thisMonth: 'This month',
    thisYear: 'This year',
    profile: 'Profile',
    dashboardMorningMonitoringMessage:
        'By keeping track of things such as your heart rate, hydration, ' +
        'training quality, injury & illness, Morning Monitoring helps you understand why illness & injury occur and ' +
        'therefore adjust your training plan accordingly',
    dontHaveStatsForSelectedPeriod: "Don't have morning monitoring stats for selected period",
    showCharts: 'Show charts',
    hideCharts: 'Hide charts',

    // calendar
    addSession: 'Add Session',
    addRecentSession: 'Add Recent Session',
    myFavourites: 'My Favourites',
    clubFavourites: 'Club favourites',
    allFavourites: 'All favourites',
    areYouSureToDeleteFavourite: 'Are you sure you want to delete this favourite?',
    assignMembers: 'Assign Members',
    pleaseAssignPermissions: 'Please assign permissions. Existing permissions will be replaced.',
    assignAndAddPermissions: 'Assign & Add Permissions',
    sessionDataSavedSuccessfully: 'Session data saved successfully.',
    atLeastOneSessionErrorMessage: 'You need to select at least 1 session before submitting.',
    note: 'Note | Notes',
    assign: 'Assign',
    loadPastSession: 'Load past sessions',
    deleteSelectedSessions: 'Delete selected sessions',
    showingResultsFrom: 'Showing results from',
    to: 'to',
    emptyResultsSet: 'Empty results set.',
    loadFutureSession: 'Load future sessions',
    areYouSureToDeleteSelectedEvent: 'Are you sure you want to delete selected event?',
    eventsSuccessfullyDeleted: 'Events successfully deleted.',
    searchTags: 'Search Tags',
    searchAthletes: 'Search Athletes',
    date: 'Date | Dates',
    start: 'Start',
    end: 'End',
    mySessions: 'My Sessions',
    allSessions: 'All Sessions',
    sessionType: 'Session Type | Session Types',
    filterResults: 'Filter Results',
    allDay: 'All day',
    selectAll: 'Select All',
    list: 'List',
    weeklySummary: 'Weekly Summary',
    trainingType: 'Training Type | Training Types',
    editSessionPermissionsErrorMessage: 'You do not have permission to edit this session',
    editEventPermissionsErrorMessage: 'You do not have permission to edit this event',
    quickAssign: 'Quick Assign',
    unselectAll: 'Unselect All',
    youHaveToSelectSessionFirst: 'You have to select a session first.',
    selectSession: 'Select session',
    doYouWantToCreateSessionOn: 'Do you want to create session on {date}?',

    // Profile
    theirAgenda: 'Their Agenda',
    noSessionsPlanned: 'Currently there are no sessions planned for',
    noSessionComing: 'No sessions coming up, plan your next session.',
    morningMonitoring: 'Morning Monitoring',
    hrZones: 'HR Zones',
    todayMorningMonitoringSummaries: 'Today’s Morning Monitoring Summaries',
    changeInHrFromYesterday: 'Change in HR from yesterday',
    changeInHrFromFiveDaysAve: 'Change in HR from 5 day avg.',
    differenceInWakingAndStandingHr: 'Diff. in waking and standing HR from yesterday',
    changeInBodyMassFromYesterday: 'Change in body mass from y’day',
    changeInPerceivedShape: 'Change in perceived shape',
    hydrationLevel: 'Hydration Level',
    trainingQuality: 'Training Quality',
    theirMostRecentSession: 'Their Most Recent Session',
    mostRecentSessionWillAppearHere: "'s most recent session will appear here.",
    past5Sessions: 'Past 5 Sessions',
    pb: 'PB',
    addData: 'Add Data',
    theirNextSession: 'Their Next Session',
    doesnHaveNextSessionPlanned: "doesn't have a next session planned.",
    isCurrentlyInNoSquads: 'is currently in no {label}.',
    hrWeight: 'HR & Weight',
    sleepShape: 'Sleep & Shape',
    kilogram: 'Kilogram | Kilograms',
    entryBefore: 'Entry Before',
    mean: 'Mean',
    bodyWeightKg: 'Body Weight (kg)',
    sleep: 'Sleep',
    shape: 'Shape',
    severelyDehydrated: 'Severely Dehydrated',
    noHydration: 'No Hydration',
    thereAreNoNotifications: 'There are no notifications.',
    settings: 'Settings',
    markAllAsRead: 'Mark all as read',
    seeAll: 'See All',
    notificationSettings: 'Notification Settings',
    web: 'Web',
    mobile: 'Mobile',
    rowingStats: 'Rowing Stats',

    // profile drv
    drv: 'DRV',
    personal: 'Personal',
    contactInfo: 'Contact Info',
    degreeAbbreviation: 'Degree Abbreviation',
    title: 'Title',
    fax: 'Fax',
    address: 'Address',
    street: 'Street',
    postCode: 'Post Code',
    state: 'State',
    city: 'City',
    federationInfo: 'Federation info',
    clubInfoAndStatus: 'Club Info and Status',
    educationCoachesInfo: 'Education, Coaches Info',
    myDetails: 'My Details',
    otherDetails: 'Other Details',
    rowingDetails: 'Rowing Details',
    noResultsWithinDateRange: 'No results within this date range.',
    training: 'Training',
    physiology: 'Physiology',
    analysis: 'Analysis',
    trainingAndPerformance: 'Training & Performance',
    testResultsW: 'Test Results (w)',
    trainingVolume: 'Training Volume',
    injuryIllnessTimeline: 'Injury & Illness Timeline',
    trainingVolumes: 'Training Volumes',
    enduranceTraining: 'Endurance Training',
    strengthTraining: 'Strength Training',
    zone: 'Zone | Zones',
    hour: 'Hour | Hours',
    endurance: 'Endurance',
    trainingCompleted: 'Training Completed',
    noOfSessions: 'No. of Sessions',
    trainingLoad: 'Training Load',
    rowingDistance: 'Rowing Distance',
    injuries: 'Injuries',
    illnessTypes: 'Illness Types',
    injuryTypes: 'Injuries Types',
    manual: 'Manual',
    imported: 'Imported',
    trainingLoadScore: 'Training Load Score | Training Load Scores',
    value: 'Value',
    latestResult: 'Latest Result',
    latest: 'Latest',
    pbResult: 'PB result',
    planned: 'Planned',
    actual: 'Actual',
    volume: 'Volume | Volumes',
    latestMaxLactate: 'Latest Max Lactate',
    testScores: 'Test Score | Tests Scores',
    vo2Max: 'VO2Max',
    vo2MaxPerKg: 'VO2Max per Kg',
    percentage: 'Percentage',
    latestP2000Index: 'Latest P2000m Index',
    latestP6000Index: 'Latest P6000m Index',
    trainingZonePercentage: 'Training Zone Percentage',
    spiderDiagram: 'Spider Diagram',
    personalBest: 'Personal best',
    mostRecent: 'Most recent',
    average: 'Average',

    // reports
    trainingSummary: 'Training Summary',
    attendanceReportIsEmpty: 'Attendance reports is empty',
    selectAthlete: 'Select Athlete',
    ergoReportIsEmpty: 'Ergo report is empty',
    athleteName: 'Athlete Name',
    side: 'Side',
    mainSquad: 'Main {label}',
    bestInPeriod: 'Best in Period',
    firstInPeriod: 'First in Period',
    lastInPeriod: 'Last in Period',
    change: 'Change',
    pbGraph: 'PB Graph',
    doesNotHaveAnySpecificPieces: 'Does not have any specific pieces.',
    doesNotHaveAnyPersonalBests: 'Does not have any personal bests.',
    pieceNo: 'Piece No',
    wattsKg: 'Watts/Kg',
    rpeScore: 'RPE Score',
    ok: 'OK',
    noData: 'No Data',
    morningMonitoringDefinitions: 'Morning Monitoring Definitions',
    hrIncreaseBySevenToTenBeats: 'HR increase by 7-10 beats',
    differenceHasNarrowed: 'Difference has narrowed',
    decreased: 'Decreased',
    slightlyDehydrated: 'Slightly Dehydrated',
    between: 'Between',
    and: 'and',
    hrIncreaseByMoreThanTenBeats: 'HR increase by 10+ beats',
    injury: 'Injury',
    illness: 'Illness',
    by: 'by',
    dehydrated: 'Dehydrated',
    trafficLights: 'Traffic Lights',
    wHr: 'wHR',
    sHr: 'sHR',
    mass: 'Mass',
    trainingScore: 'Training Score',
    yourAthletesMorningMonitoringDataWillAppearHere: 'Your athletes morning monitoring data will appear here.',
    yourAthletesIllnessAndInjuryDataWillAppearHere:
        "Your athletes illness and injury data will appear here once they've completed their morning monitoring.",
    yourAthletesQualityOfTrainingWillAppearHere:
        "Your athletes quality of training will appear here once they've completed their morning monitoring.",
    report: 'Report',
    athleteErgoProgress: 'Athlete Ergo Progress',
    athleteErgoProgressText:
        'The athlete ergo progress report will allow you to see the improvements over ' +
        'time your athletes have been making on the ergo. Select an athlete and you will see all their historical results.',
    athleteWaterProgress: 'Athlete Water Progress',
    athleteWaterProgressText:
        'The athlete water progress report will allow you to see the improvements over time your athletes have been ' +
        'making on the water. See a history of their results in each boat type.',
    morningMonitoringText:
        'The morning monitoring report displays the morning monitoring data on one table ' +
        "for the group or athletes you've selected.",
    goldMedalTime: 'Gold Medal Time',
    goldMedalTimeText:
        'The GMT report lets you see the percentage (%) GMT for each piece your athletes ' +
        'have completed. This report also shows an average GMT for each piece and each athlete.',
    sessionAttendance: 'Session Attendance',
    sessionAttendanceText:
        'The session attendance report will show you the attendance status for athletes ' +
        'and {label} between a specific date range. This report allows you to look at attendance both in the future and historically.',
    ratingPerceivedExertion: 'Rating of Perceived Exertion',
    ratingPerceivedExertionText:
        'The RPE reports lets you see the rating of perceived exertion for all ' +
        'your sessions. This report shows averages to make it easier to see which sessions stand out.',
    trainingSummaryText:
        'The Training Summary Report shows you the breakdown of how many sessions your ' +
        'athletes have done, their ill/injured stats, ergo and gps data stats and the planned mileage and time for each athlete.',
    trainingSummaryReportIsEmpty: 'Training summary report is empty.',
    trainingSessions: 'Training sessions',
    sessionAttended: 'Session Attended',
    missedDueToIllness: 'Missed due to illness',
    missedDueToInjury: 'Missed due to injury',
    missedDueToAbsence: 'Missed due to absence',
    gpsDataImported: 'GPS Data (imported)',
    ergoDataEntered: 'Ergo Data (entered)',
    morningMonitoringCompleted: 'Morning Monitoring completed',
    waterReportIsEmpty: 'Water reports is empty.',
    allBoatTypes: 'All Boat Types',
    export: 'Export',
    exportToExcel: 'Export to Excel',
    aveGmt: 'Ave. GMT',
    reportsOverall: 'Overall',
    rpeReportIsEmpty: 'RPE report is empty for the selected date range.',
    reset: 'Reset',
    stepTests: 'Step Tests',
    table: 'Table | Tables',
    graph: 'Graph | Graphs',
    vo2Tests: 'Vo2 Tests',
    k2Tests: '2k Tests',
    k6Tests: '6k Tests',
    errorsOccurredDuringImport: 'Errors occurred during the import:',
    gmtReportIsEmpty: 'GMT report is empty for the selected date range.',
    teamErgoSummary: 'Team Ergo Summary',
    teamErgoSummaryText:
        'The Team Ergo Report will allow you to see the result and rate of athletes in your team over a specific period of time.',
    teamErgoSummaryIsEmpty:
        'Results for your Teams Ergos will show here. Team Ergo Summary is empty for the selected date range.',
    dataEntered: 'Data Entered',
    noResultsForMorningMonitoringReport: 'No results for morning monitoring report',
    individualView: 'Individual view',
    ergoReport: 'Ergo',
    rowingReport: 'Rowing',
    test: 'Test | Tests',

    // errors
    pageNotFound: 'Page not found!',
    textErrorPage: 'Try going back, or ask us for help.',
    thereProblem: 'There’s a problem…',
    weWillBeBackSoon: 'We’ll be back soon!',
    text503Page:
        'We are currently down for maintenance. We expect the site to be back from Monday 9am GMT. ' +
        'Thank you for your patience.',
    outOfRangeError: 'Value must be between {min} and {max}',
    redirectingToDashboard: 'Redirecting to the dashboard',
    doNotHavePermissionToSeeAthleteProfile: 'You do not have permission to see athlete profile.',
    unauthorized: 'Unauthorized',
    unauthorizedErrorPage: "You don't have permission to access this page.",

    // add crew
    addRecent: 'Add Recent',
    recentCrewsListEmpty: 'Recent crews list is empty',
    changeSportTypeWarning: 'Changing boat type will discard current changes. Do you want to continue?',
    back: 'Back',
    searchAthleteOrDragHere: 'Search Athlete or drag here',
    showAthletes: 'Show athletes',
    hideAthletes: 'Hide athletes',
    boat: 'Boat | Boats',
    addingCrewsFor: 'Adding crews for',

    // wall posts
    writeSomethingOnTheWall: 'Write something on the wall…',

    // billing
    currentPlanInfo: 'Current Plan Info',
    billingInfo: 'Billing Info',
    transaction: 'Transaction | Transactions',
    annually: 'Annually',
    annual: 'Annual',
    updatePaymentDetails: 'Update Payment Details',
    addPaymentDetails: 'Add Payment Details',
    changePlan: 'Change Plan',
    selectPlan: 'Select Plan',
    updatePlan: 'Update Plan',
    plan: 'Plan',
    perUser: 'per user',
    for: 'for',
    subscriptionPlan: 'Subscription Plan',
    paymentDetails: 'Payment Details',
    member: 'Member | Members',
    selectPlanAndAddPayment: 'Select Plan and Add Payment',
    preferredCurrency: 'PREFERRED CURRENCY',
    chooseAPlan: 'CHOOSE A PLAN',
    billedMonthly: 'Billed Monthly',
    perMonth: 'per month',
    billedAnnually: 'Billed Annually',
    perYear: 'per year',
    payBy: 'PAY BY',
    card: 'Card',
    paymentAmount: 'Payment amount',
    nameOnCard: 'Name on card',
    cardNumber: 'Card number',
    expiryDate: 'Expiry date',
    securityCode: 'Security code',
    securityCodeTooltip: 'The last 3 digits of your CVC number on the back of your card',
    zipPostalCode: 'ZIP/Postal Code',
    zipPostalCodeTooltip: 'Please enter your Zip or Post Code here',
    pay: 'Pay',
    freeTrial: 'Free Trial',
    yourClubsFreeTrialExpiresIn: 'Your clubs free trial expires in',
    yourClubsFreeTrialHasExpired: 'Your clubs free trial has expired',
    currency: 'Currency | Currencies',
    directBankTransfer: 'Direct bank transfer',
    youSubscriptionHasExpired: 'Your subscription has expired',
    nextBillDate: 'Next bill date:',
    yourAccountHas: 'Your account has',
    subscriptionCredit: 'subscription credit',
    thisWillBeSubtractedFromNextPayment: 'This will be subtracted from your next payment',
    yourClubCurrentlyDoesNotHaveAPlan: 'Your club currently does not have a plan',
    currentPlan: 'Current plan',
    youTeamCurrentChargeFor: 'Your teams current charge for',
    unlimited: 'Unlimited',
    totalCost: 'Total cost',
    yourSubscriptionExpiredOn: 'You subscription expired on',
    yourFreeTrialExpiredOn: 'Your free trial expired on',
    payHere: 'Pay Here',
    cancelSubscription: 'Cancel Subscription',
    areYouSureToCancelSubscription: 'Are you sure you want to cancel subscription?',
    expiryDateIsInvalid: 'Expiry date is invalid',
    activePlan: 'Active Plan',
    planExpired: 'Plan Expired',
    billingPerUser: 'Per User',
    billingUnlimitedUsers: 'Unlimited Users',
    address1: 'Address 1',
    address2: 'Address 2',

    // billing licence expired
    orSwitchToAnotherClubOnLudum: 'Or switch to another club on Ludum',
    sendAdministratorLicenceNotification: 'Send administrator licence notification',
    itLooksLikeYouLicenceHasExpiredWith: 'It looks like your licence has expired with',
    clickBelowToSendANotificationToTheClubAdministratorToRenewYouLicence:
        'Click below to send a notification to the club administrator to renew your licence',

    // first time user
    welcomeTo: 'Welcome to Ludum',
    firstTimeUserIntoText1:
        'We’d like to welcome you to Ludum, the rowing specific training and organisation ' +
        'platform. We are excited in helping you train better and going faster.',
    firstTimeUserIntoText2: 'To help you train better and go faster please select how you’d like to use Ludum',
    asAnAthlete: 'As an athlete',
    AsACoach: 'As a coach',
    withoutAClub: 'Without a club',
    useAsIndividual: 'Use as an individual',
    pendingClubs: 'Pending clubs',

    // onboarding
    welcomeToLudum: 'Welcome to Ludum',
    gettingStartedIntro1:
        'In this panel we have the key steps to successfully use Ludum. We have noticed that clubs who complete ' +
        'this process fully have a much higher success rate on the water.',
    gettingStartedIntro2:
        "The process of setting your club up takes less than 5 minutes and by following each step you'll set your " +
        'club up for success.',
    gettingStartedIntro3:
        'If you have any further questions, please do get in touch by clicking the blue button in the bottom right ' +
        'hand corner.',
    onboardingYourAgendaInfo1: 'We’ll summarise your upcoming sessions here.',
    onboardingYourAgendaInfo2: 'to get started.',
    createASession: 'Create a session',
    viewCalendar: 'View Calendar',
    calendar: 'calendar',
    onboardingNextSessionInfo:
        'In depth summary for your next session will always appear here. View your full schedule in your',
    onboardingMostRecentSessionInfo: 'Results from your most recent session will always appear here.',
    here: 'here',
    onboardingNotificationsInfo1: 'In Notifications we’ll breakdown of everything that’s relevant to you.',
    onboardingNotificationsInfo2: 'You can edit your notification settings',
    gettingStarted: 'Getting Started',
    gettingStartedShort: 'GS',

    // CTL
    ets: 'ETS',
    trimp: 'TRIMP',
    foster: 'Foster',
    scoreRange: 'Score range',
    totalScore: 'Total Score',
    noTrainingScoreDataMessage:
        'Why do not I see any data here? There are two reasons: Either you have not yet ' +
        'imported training data or the required load score is missing necessary information, ie. ' +
        'Exposure feeling in the app at the Foster score or imported heart rate data for TRIMP or ETS.',
    days7: '7 days',
    days28: '28 days',
    ratio: 'Ratio',

    you: 'You',

    // pagination
    perPage: 'Per page',
    showing: 'Showing',
    from: 'from',
    page: 'Page | Pages',

    // Training Load Scores
    cardiacTrainingLoadScores: 'Training Scores',
    byWeek: 'By Week',
    byMonth: 'By Month',
    byDay: 'By Day',
    avgScore: 'Avg. Score',
    maxScore: 'Max Score',
    minScore: 'Min Score',

    // invite member
    addUser: 'Add user',
    inviteAdditionalUsersChargeMessage: 'Additional users will be added to your clubs next bill',
    multiInviteAdditionalUsersChargeMessage: 'You may incur an additional charge when an user accepts your invitation.',

    // first time user
    invitedClubs: 'Invited to clubs',

    // German import slider
    importDrvFile: 'Import DRV File',
    selectFileToUpload: 'Select File to Upload',
    profileImport: 'Profile Import',
    stepTestImport: 'Step Test Import',
    vo2TestImport: 'VO2 Test Import',
    k2TestImport: '2K Test Import',
    k6TestImport: '6K Test Import',
    importFile: 'Import File',
    row: 'Row | Rows',

    // step tests
    firstTest: 'First Test',
    lastTest: 'Last Test',
    pbOverview: "PB's Overview",

    // upgrade to Performance
    upgrade: 'Upgrade',
    upgradeNow: 'Upgrade Now',
    upgradeToPerformance: 'Upgrade to Performance',
    upgradeHeader1: 'Make your best even better',
    upgradeText1:
        'Made for coaches & athletes who want to enhance every aspect of their training, ' +
        '<b>Performance</b> supercharges your Ludum experience.',
    upgradeText1_2: 'You can cancel or downgrade at any time',
    upgradeHeader2: 'Use <b>third-party apps</b> to take your training further',
    upgradeText2:
        'By importing <b>GPS</b> and <b>Heart Rate</b> data from your sessions, ' +
        'Ludum can give you detailed feedback that’ll help you understand your training better. ' +
        'With <b>Auto Import</b> we’ve made it fast & easy to integrate Ludum with your favourite third-party apps.',
    upgradeText2_2: 'Want everything in one place?',
    upgradeHeader3: '<b>Detailed reports</b> give you everything you need to know ',
    upgradeText3:
        '<i>Performance</i> allows users to feedback on how their sessions felt, ' +
        'as well as record how you performed against pre-set Gold Medal Times (GMTs). Detailed reporting ' +
        'collates this data and gives it back to you in an easy-to-understand, visual format.',
    upgradeText3_2: 'Want extra feedback on your sessions?',
    upgradeHeader4: 'Our innovative <b>Endurance Training Score</b> helps keep track of your training load',
    upgradeText4:
        'We’ve created a system, exclusive to Ludum, to help athletes keep track of how hard their ' +
        'training over the course of a season. By collating Heart Rate and training data, an ETS score can help ' +
        'indicate when you need train more or less, help understand why injuries occur and help …xxxx',
    upgradeText4_2: 'Want to take advantage of cutting-edge technology?',
    upgradeText5: '… and more',
    upgradeHeader6: 'Alternative Sessions',
    upgradeText6: 'Record alternative session data in one session making it easy to compare.',
    upgradeHeader7: 'Weekly Summary',
    upgradeText7: 'See a breakdown of each week and compare week to week.',
    upgradeHeader8: 'Competitive Sessions',
    upgradeText8: 'Change the status of sessions, allow athletes to see all data or only their own.',

    // welcome
    bePartOfATeam: 'Be Part Of A Team',
    getStarted: 'Get Started',
    trainLikePro: 'Train like a PRO',
    team: 'Team | Teams',
    individual: 'Individual',
    welcomeToLudumMessage: 'Please select how you’d like to use Ludum',
    trackYourProgress: 'Track Your Progress',
    allInYourHands: 'All In Your Hands',
    organizeYourTeam: 'Organize Your Team',
    communicateWithYourTeam: 'Communicate With Your Team',
    startUsingLudumToday: 'Start Using Ludum Today',
    startOver: 'Start over',

    // session results
    selectAthleteFromDropdown: 'Please select athlete from dropdown',
    avePeakForcePosition: 'Ave. Peak Force Position',

    // session attendance
    searchParticipants: 'Search participants',
    listOfAthletesIsEmpty: 'List of athletes is empty.',
    listOfCoachesIsEmpty: 'List of coaches is empty.',

    // quick assign
    cannotAddAnythingWhileEverybodyIsSelected: "Can't add anything while everybody is selected",

    // import data
    noSessions: 'No sessions',

    // Add MM
    sleepTime: 'Sleep Time',

    // Notes
    attach: 'Attach',
    noFileInThisNote: 'No file in this note',
    fileName: 'File name',
    delete: 'Delete',
    byDate: 'By Date',
    asc: 'asc',
    desc: 'desc',
    areYouSureToRemoveNote: 'Are you sure you want to remove the note?',
    addPrivateNoteAboutSession: 'Add a private note about the session',
    addPrivateNoteAboutEvent: 'Add a private note about the event',
    areYouSureToRemoveFile: 'Are you sure you want to remove the file?',
    privateNote: 'Private Note | Private Notes',
    addPrivateNote: 'Add Private Note',

    // Search
    search: 'Search',
    searchProfileSquadsEvents: 'Search for profiles, squads and events',
    seeAllSquads: 'See all {label}',
    seeAllSessions: 'See all sessions',
    seeAllProfiles: 'See all profiles',
    event: 'Event | Events',
    noSearchResults: 'No search results',
    doNotHavePermissionToViewThisPage: "You don't have permission to view this page.",

    // Login Page
    //orLoginWith: 'Or login with',
    alreadyMember: 'Already a member',
    resendActivationEmail: 'Resend activation email',

    // Home
    lastSession: 'Last Session',
    avgSplit: 'Avg. Split',
    vsLast: 'vs. last',
    meter: 'meter | meters',
    trainingIntensity: 'Training Intensity',
    per: 'per',
    backToNotification: 'Back to notification',
    setTime: 'Set time',
    hoursOfSleep: 'Hours Of Sleep',
    sessionToImport: 'Session to import',
    widgetAutoImportSubtitle: 'You have no new sessions to import.',
    widgetAutoImportIntro: 'Your next import will appear here when it is ready.',
    myTraining: 'My Training',
    health: 'Health',
    trainingScores: 'Training Scores',
    noIntensityForThis: 'No intensity for this',
    agenda: 'Agenda',
    unread: 'unread',

    // Invitation for membership
    saveYourProfile: 'Save Your Profile',
    cancelThisInvitation: 'cancel this invitation',
    acceptTheInvitation: 'Accept the Invitation',
    wouldYouLikeToJoin: 'Would you like to join',
    hello: 'Hello',
    textInvitedAccount: 'you have been invited to join',
    textInvitedWithAccount1: 'By accepting the invitation',
    textInvitedWithAccount2: 'will be added to your account.',
    textInvitedWithoutAccount: 'By accepting the invitation you can continue to create an account in Ludum.',
    textOnSaveYourProfile: "If you'd like to use Ludum you can continue by saving your profile.",
    invitationAlreadyAccepted: 'Invitation already accepted',
    invitationExpired: 'Invitation expired',

    // Add scores
    sendNotificationAfterSave: 'Send Notification after save',
    viewResultsAfterSave: 'View Results page after save',

    // kayak/canoe
    kayakCanoe: 'Kayak/Canoe',
    rowing: 'Rowing',
    athleteRowingProgress: 'Athlete Rowing Progress',
    athleteRowingProgressText:
        'The athlete rowing progress report will allow you to see the improvements over time your athletes have ' +
        'been making on the water. See a history of their results in each boat type.',

    // default Ludum user
    ludum: 'Ludum',
    user: 'User | Users',

    // Session view results - new
    yourResults: 'Your Results',
    summary: 'Summary',
    imports: 'Imports',
    pieceResults: 'Piece Results',
    piecesSummary: 'Pieces Summary',
    athleteHeartRate: 'Athlete Heart Rate',
    totalReps: 'Total reps',
    typeOfExercises: 'Type of exercises',
    athleteEnduranceTrainingScore: 'Athlete Endurance Training Scores',
    noFilesUploaded: 'No files have been added, please import data',
    showMore: 'Show more',
    crewHr: 'Crew HR',
    noImportedFiles: 'No files have been imported, please import files to view results',
    showAll: 'Show all',
    aveTimeScore: 'Ave. Time Score',
    aveDistanceScore: 'Ave. Distance Score',
    viewResults: 'View Results',

    // Create/edit club
    website: 'Website',
    defaultSport: 'Default sport',
    selectDefaultSport: 'Select default sport',
    unitsOfMeasurement: 'Units of measurement',
    selectUnitsOfMeasurement: 'Select units of measurement',
    selectTimezone: 'Select timezone',

    // not authorized
    notAuthorizedToSeeThisPage: 'You are not authorized to see this page',

    // titles
    titleLogin: 'Login',
    titleSignUp: 'Sign up',
    titleForgotPassword: 'Forgot password',
    titleHome: 'Home',
    titleDashboard: 'Dashboard',
    titleSession: 'Session',
    titleSessions: 'Sessions',
    titleAddCrews: 'Add crews',
    titleEditCrews: 'Edit crews',
    titleEvent: 'Event',
    titleReports: 'Reports',
    titleSettings: 'Settings',
    titleSquads: '{label}',
    titleClubMembers: 'Club members',
    titleProfile: 'Profile',
    titleLicenceExpired: 'Licence expired',
    titleUpgrade: 'Upgrade',
    titleWelcome: 'Welcome',
    titleSearchResults: 'Search Results',
    titleCrews: 'Crews',
    titleInvitationForMembership: 'Invitation for Membership',
    titleResendActivationEmail: 'Resend activation email',

    // modals
    removeClub: 'Remove club',
    areYouSureToRemoveClub: 'Are you sure you want to remove the club?',
    removeUser: 'Remove User',
    areYouSureToRemoveUser: 'Are you sure you want to remove the user?',
    missingAthletes: 'Missing athletes',

    // Crews
    saveChanges: 'Save Changes',
    isAlreadyOn: 'is already on',

    /// RPE
    veryEasy: 'Very Easy',
    easy: 'Easy',
    moderate: 'Moderate',
    aBitExhausting: 'A bit exhausting',
    exhausting: 'Exhausting',
    veryExhausting: 'Very Exhausting',
    veryVeryExhausting: 'Very, Very Exhausting',
    maximumEffort: 'Maximum Effort',

    // settings - club list
    areYouSureToDeleteClub: 'Are you sure you want to delete club?',

    // session
    thisSessionBelongsToAnotherClub: 'This session belongs to another club.',
    thisEventBelongsToAnotherClub: 'This event belongs to another club.',

    // rpe
    informationRpeTitle: 'Numbers of stars is equal with number',

    favorite: 'Favorite',

    deleteClub: 'Delete club',
    editClub: 'Edit club',
    youAreAlreadyInThisClub: 'You are already in this club!',
    notificationWillBeSentImmediately: 'Notification will be sent immediately',
    clubEmail: 'Club email',
    clickHereTo: 'Click here to',
    useWithoutClub: 'Use without Club',

    allDayEvent: 'All day event',
    tag: 'Tag | Tags',

    // add member
    invalidFile: 'Invalid file',
    invalidFileType: 'Invalid file type',
    uploadFromFile: 'upload from file',
    sampleFile: 'sample file',
    enterManuallyOr: 'Enter manually or',
    use: 'Use',
    toEasyMakeMultiMembersImport: 'to easy make multi members import',
    chooseFromFileOrDragAndDrop: 'Choose from file or drag and drop',
    added: 'Added',
    error: 'error | errors',
    addMember: 'Add Member',
    resetAll: 'Reset all',
    addNew: 'Add new',
    membersUploadedSuccessfully: 'Members uploaded successfully.',
    userWillBeInvitedToClub: 'User will be invited to club',
    clickToInviteUserToClub: 'Click to invite user to club',

    // session attendance tooltip
    viewAllParticipantsOnThisSession: 'View all participants on this session',

    // Update notification
    webAppUpdated: 'There is a new version of Ludum. Please',
    webAppUpdatedReload: 'Reload',

    // calendar share link
    shareCalendarLink: 'Share Calendar link',
    shareLudumCalendar: 'Share Ludum calendar',
    copyLink: 'Copy link',
    copiedToClipboard: 'Copied to clipboard',
    shareIntroTopTextModal: 'Copy this url to share Ludum calendar with other platforms.',
    read: 'Read',
    tutorial: 'tutorial',
    shareIntroDownTextModal: 'for how to share Ludum calendar.',

    // crews page
    category: 'Category | Categories',
    age: 'Age',
    sportType: 'Sport Type',
    deleteSelectedCrews: 'Delete selected crews',
    noPermission: 'No permission',
    youDontHavePermissionToDeleteThisCrew: "You don't have permission to delete this crew",
    areYouSureToDeleteSelectedCrews: 'Are you sure you want to delete selected crews?',
    crewsSuccessfullyDeleted: 'Crews successfully deleted.',

    // reports - morning monitoring
    numberOfInjuryIllness: 'Number of Injury / Illness',
    ave: 'ave.',
    maxGmtByPiece: 'Max GMT by piece',

    // Team Ergo Summary report
    missingOrIncompleteResults: 'Missing or Incomplete results',
    spm: 'spm',

    // crews
    showFilter: 'Show Filter',
    crewMessageNoData1: 'To add a crew please select a boat from above.',
    crewMessageNoData2: 'Crews will be added to all pieces.',
    publish: 'Publish',
    unpublish: 'Unpublish',
    seatRacing: 'Seat racing',
    youHaveToSelectCrewFirst: 'You have to select a crew first.',
    thereAreNoCrews: 'There are no crews',

    // home widget
    noSquadsInThisClub: 'No {label} in this club',
    addSquads: 'Add {label}',

    // Resend activation email
    resendActivationEmailIntroText:
        'Your user account has not been activated yet. Please check your email to verify your account.',

    // finish club setup - notification
    finishClubSetup: 'It is recommended to finish club setup on a desktop computer.',

    // create session/event further action modal
    saveAndCreateNew: 'Save and Create new',
    saveAndExit: 'Save and exit',
    returnToSessionCreate: 'Return to session create',
    addCrews: 'Add Crews',

    profileImage: 'Profile image',

    // team report
    kaizenTeam: 'Kaizen Team',
    kaizenTeamText:
        'The Kaizen Team report gives you the power to compare the rate of improvement of your athletes over time.',
    noAthleteOrSquadMessage:
        'Welcome to the Kaizen Team Report, this report gives you the power to compare the rate ' +
        'of improvement of your athletes over time.<br><br>' +
        'It also includes the added dimension of comparing this to the actual training load done by each athlete.<br>' +
        'In order to show some data please select some athletes either by name or by selecting a Squad. ' +
        'Then pick a date range that is of interest to you.',
    pleaseSelectAthlete: 'Please select athlete',
    trainingTime: 'Training Time',
    sessionsCompleted: 'Session completed',
    sessionsMissed: 'Sessions missed',
    sessionDate: 'Session date',
    percentageImprovement: 'Percentage improvement',
    meanPercentageOfGroup: 'Mean Percentage of group',
    maxPercentageOfGroup: 'Max Percentage of group',
    cumulativeImprovement: 'Cumulative Improvement',
    noTrainingLoadScoreData: 'No training load score data',
    noPercentageImprovementData: 'No percentage improvement data',
    perWeek: '/w',
    structure: 'Structure | Structures',
    cumulativeImprovementTooltip:
        'This graph shows the improvement of each athlete on the indoor rowing machine over ' +
        'the date range selected. The improvement is produced by comparing like for like sessions, and calculating ' +
        'the improvement (in watts) between the two. This means we are able to compare two athletes improvement ' +
        'even if they do different Ergometer Sessions.',
    trainingLoadScoreTooltip:
        'Here you can see the change in training load of every athlete you select, ' +
        'over the date range you have chosen.<br><br>' +
        'There are four type of Training load on offer on this graph.<br>' +
        '    1. ETS – Endurance Training Score<br>' +
        '    2. Trimp – Training Impulse<br>' +
        '    3. Foster – RPE x training time<br>' +
        '    4. RPE – Rate of Perceived Effort',
    athletesSummaryTooltip:
        'A list of all athletes you have selected displaying the total training time, the total ' +
        'number of sessions completed as well as the number that have been missed. We also display the total and ' +
        'weekly average of the Training Load Score you selected in the top Graph. The overall improvement is also ' +
        'put here to compare improved performance to training.',
    individualSummaryTooltip:
        'Once you select a particular athlete from your group, then we display all the ' +
        'ergometer sessions that were completed in that date range.  We show the improvement for each session as ' +
        'well as the running total improvement. Also for comparison we show the mean and max improvement for ' +
        'that given session.',
    individualResults: 'Individual results',
    showCrew: 'Show crew',

    sessionInfo: 'Session info',

    quickAssignInfo:
        'In order to make it easier to create training sessions for many people in one go we have developed the ' +
        'quick assign feature. Please enter the name of a squad or a list of people into this box then simply drag ' +
        'and drop sport types, recent sessions or favourites into the day and time you want the session to happen. ' +
        'All those names will be assigned to those sessions and the session structures will also be transposed from ' +
        'the recents and favourites.',

    messageFooterPublicPages: 'Your training history only begins the day you start collecting your training data.',
    morningMonitoringLog: 'Morning Monitoring Log',
    privacySettings: 'Privacy Settings',
    allCoaches: 'All Coaches',
    specificCoaches: 'Specific Coaches',
    allCoachesExcept: 'All Coaches except',
    onlyMe: 'Only me',
    whoCanSeeMyProfileAndReports: 'Who can see my profile and reports?',
    float: 'Float',
    garmin: 'Garmin',
    polar: 'Polar',
    suunto: 'Suunto',
    select: 'Select',

    // Equipment List.
    equipmentList: 'Equipment List',
    allEquipment: 'All Equipment',
    equipmentCategory: 'Equipment Category',
    categoryName: 'Category name',
    enterNameOfNewCategory: 'Enter name of new category',
    addCategory: 'Add Category',
    editCategory: 'Edit Category',
    deleteCategory: 'Delete Category',
    areYouSureToDeleteCategory: 'Are you sure you want to delete this category?',
    addEquipment: 'Add Equipment',
    noEquipment1: 'No equipment. Click to',
    noEquipment2: 'to add on list of equipment.',
    noCategory1: 'No category. Click to',
    noCategory2: 'to add equipment category.',
    searchByNameOrSerialNumber: 'Search by name or serial number',
    serialNumber: 'Serial number',
    dateBought: 'Date Bought',
    dateSold: 'Date Sold',
    minimaxSpecific: 'Minimax specific',
    hardwareSettings: 'Hardware settings',
    samplingRates: 'Sampling rates',
    totalRunningTime: 'Total running time',
    correctionFactors: 'Correction factors',
    unitIntegrity: 'Unit integrity',
    dataStorageCapacity: 'Data storage capacity',
    memoryAvailable: 'Memory available',
    accuracyFactors: 'Accuracy factors',
    lastLog: 'Last Log',
    viewAllLogs: 'View all logs',
    batteryStatus: 'Battery status',
    deleteEquipment: 'Delete Equipment',
    removeEquipment: 'Remove Equipment',
    areYouSureToRemoveEquipment: 'Are you sure you want to remove this equipment?',
    assignEquipment: 'Assign Equipment',
    assignDevice: 'Assign device',
    assignedBy: 'Assigned by',

    // Challenges.
    challenge: 'Challenge | Challenges',
    viewMore: 'View more',
    allChallenges: 'All Challenges',
    addChallenge: 'Add Challenge',
    addTeam: 'Add Team',
    info: 'Info',
    teamInfo: 'Team Info',
    myTeams: 'My Teams',
    maximum: 'maximum',
    athletesPerTeam: 'athletes per team',
    myTeamResults: 'My Team Results',
    searchByTeamName: 'Search by Team Name ',
    created: 'Created',
    numberOfMembers: 'No. Of Members',
    editChallenge: 'Edit Challenge',
    deleteChallenge: 'Delete Challenge',
    teamName: 'Team Name',
    enterNameOfNewTeam: 'Enter Name of New Team',
    areYouSureToRemoveChallengeTeam: 'Are you sure you want to remove this challenge team?',
    addChallenges: 'Add Challenges',
    currentChallenges: 'Current Challenges',
    futureChallenges: 'Future Challenges',
    pastChallenges: 'Past Challenges',
    teamsLimitation: 'Teams Limitation',
    visitLudum: 'Visit Ludum',
    totalNoOfStrokes: 'Total No. of Strokes',
    pos: 'Pos.',
    poweredBy: 'Powered by',
    challengeBoardInfoText:
        'Ludum enables you and your team to keep winning and achieving better results through the power of ' +
        'performance data, better organisation and smooth communication. Empower athletes to train at the right ' +
        'intensity levels, helping to prevent injury and illness and get the edge that sets the winners apart ' +
        'from others, while a coach has a convenient way of adapting training plans to achieve high performance and ' +
        'a steady athlete development pace.',
    aveStrokeRate: 'Ave. Stroke Rate',
    howToUseChallenges: 'How to use challenges',
    step: 'Step',
    challengeStep1Text: 'Login or Sign up on',
    challengeStep2Text: 'Select Challenge and "Add Team"',
    challengeStep3Text: 'and connect to Ludum',
    download: 'Download',
    floatApp: 'Float app',
    thereAreNoAthletes: 'There are no athletes',
    endTime: 'End Time',
    noOfHeartbeats: 'No. of Heartbeats',
    publicChallengesHowToUseTitle: 'Challenges for all',
    publicChallengesHowToUseSubTitle: 'Compete or Complete with more sports',
    publicChallengesHowToUseText1: 'Ludum Challenges offers the most innovative series of challenges, appealing to those who want to compete or complete. Whether you want to run, swim, cycle or row indoors, we have it here for you!',
    publicChallengesHowToUseText2: 'Compete: Pit yourself against other individuals or teams to see how you compare',
    publicChallengesHowToUseText3: 'Complete: Test your own determination. It does not matter what your level of performance is you can still be at the top of the leaderboard.',
    publicChallengesHowToUseText4: 'Challenges will be for specific sports or all sports.',
    publicChallengesHowToUseText5: 'See our',
    publicChallengesHowToUseText5Link: 'Challenges Guide',
    publicChallengesHowToUseSportTypes: 'Sport Types',
    publicChallengesHowToUseSportTypesText: 'Swimming, Running, Cycling, Rowing Indoors',
    publicChallengesHowToUseCompete: 'Compete',
    publicChallengesHowToUseCompeteText: 'fastest, higher, stronger',
    publicChallengesHowToUseComplete: 'Complete',
    publicChallengesHowToUseCompleteText: 'most time, most distance, most strokes (Indoor Rowing), most heartbeats (all Sports)'
};
